import { TblUserData } from "../../models/UserData";

export class AddUserData {
  static readonly type = "[UserData] add";
  constructor(public payload: TblUserData) {}
}

export class RemoveUserData {
  static readonly type = "[UserData] remove";
  constructor() {}
}
